import { Injectable, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateInvoiceFormGroup } from './create-invoice-form-group.interface';
import { CreateInvoiceLineFormGroup } from './create-invoice-line-form-group.interface';
import { CreateInvoiceLineDefaults, CreateInvoiceLineFormModel } from './create-invoice-line-form.model';

@Injectable()
export class CreateInvoiceFormModel {
  private readonly formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    invoiceDate: 'invoiceDate',
    dueDate: 'dueDate',
    lines: 'lines',
  } as const;

  public readonly form: FormGroup<CreateInvoiceFormGroup>;

  constructor() {
    const formBuilder = this.formBuilder;

    this.form = formBuilder.group<CreateInvoiceFormGroup>({
      invoiceDate: new FormControl<string | null>(null, { validators: [Validators.required] }),
      dueDate: new FormControl<string | null>(null),
      lines: formBuilder.array<FormGroup<CreateInvoiceLineFormGroup>>([]),
    });
  }

  public get lines(): FormArray<FormGroup<CreateInvoiceLineFormGroup>> {
    return this.form.controls.lines;
  }

  public addLine(defaults: CreateInvoiceLineDefaults): FormGroup<CreateInvoiceLineFormGroup> {
    const lineForm = CreateInvoiceLineFormModel.buildFormGroup(this.formBuilder, defaults);
    this.lines.push(lineForm);
    return lineForm;
  }

  public clearLines(): void {
    while (this.lines.length > 0) {
      this.lines.removeAt(0);
    }
  }
}
